import _ from 'lodash';

export default function isLodashCompatibleCriteria(inputCriteria, mongoQuery) {
  if (!_.isObject(inputCriteria)) {
    return false;
  }

  if (!_.every(_.keys(inputCriteria), k => isKeyValueLodashCompatible(k, inputCriteria[k]))) {
    return false;
  }

  const keys = _.keys(inputCriteria);
  const hasMultipleKeys = keys.length > 1;
  const dumbEqualCriteria = keys.reduce(
    (acc, key) => {
      if (hasMultipleKeys) {
        acc.$and.push({ [key]: { $eq: inputCriteria[key] } });
      } else {
        acc[key] = { $eq: inputCriteria[key] };
      }
      return acc;
    },
    hasMultipleKeys ? { $and: [] } : {}
  );

  if (!_.isEqual(dumbEqualCriteria, mongoQuery)) {
    return false;
  }

  return true;
}

function isKeyValueLodashCompatible(key, value) {
  if (_.startsWith(key, '$')) {
    return false;
  }
  if (_.isObject(value)) {
    return false;
  }
  if (_.includes(key, '.')) {
    return false;
  }

  return true;
}
